import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { ActionsIcon } from '../../../../assets';
import EngagementSegments from './engagementSegments';
import TriggerEngagement from './triggerEngagement';
import PropTypes from 'prop-types';

function PhysicianEngagement() {
    return (
        <Grid item xs={12}>
            <Grid container spacing={3}>
                {/* Field Engagement */}
                <Grid item xs={4}>
                    <EngagementSegments />
                </Grid>

                {/* Field Trigger Engagement */}
                <Grid item xs={8}>
                    <TriggerEngagement />
                </Grid>
            </Grid>
        </Grid>
    );
}

PhysicianEngagement.prototypes = { isConfigReady: PropTypes.bool };

export default PhysicianEngagement;
